export { default as DotsAnimation } from './DotsAnimation.vue'
export { default as SpinnerAnimation } from './SpinnerAnimation.vue'
export { default as VanAnimation } from './VanAnimation.vue'
export { default as CoachBusAnimation } from './CoachBusAnimation.vue'
export { default as SchoolBusAnimation } from './SchoolBusAnimation.vue'
export { default as ShuttleAnimation } from './ShuttleAnimation.vue'
export { default as LimoAnimation } from './LimoAnimation.vue'
export { default as TaxiAnimation } from './TaxiAnimation.vue'
export { default as StaplerBusAnimation } from './StaplerBusAnimation.vue'
export { default as CloudSyncAnimation } from './CloudSyncAnimation.vue'
export { default as RouteStopsAnimation } from './RouteStopsAnimation.vue'

// Map animation keys to components
export const animationComponents = {
  'dots': 'DotsAnimation',
  'van': 'VanAnimation',
  'coach': 'CoachBusAnimation',
  'school': 'SchoolBusAnimation',
  'shuttle': 'ShuttleAnimation',
  'limo': 'LimoAnimation',
  'taxi': 'TaxiAnimation',
  'stapler': 'StaplerBusAnimation',
  'cloud': 'CloudSyncAnimation',
  'route': 'RouteStopsAnimation',
  'spinner': 'SpinnerAnimation',
}
